const oneHopeLogo = `
.................................................................................
.................................................................................
.................................................................................
...d31337b...888b....888.8888831337.888....888...d31337b...8888888b...8888831337.
.d88P"."Y88b.8888b...888.888........888....888.d88P"."Y88b.888...Y88b.888........
.888.....888.88888b..888.888........888....888.888.....888.888....888.888........
.888.....888.888Y88b.888.8831337....8883133788.888.....888.888...d88P.8831337....
.888.....888.888.Y88b888.888........888....888.888.....888.8831337P"..888........ 
.888.....888.888..Y88888.888........888....888.888.....888.888........888........
.Y88b...d88P.888...Y8888.888........888....888.Y88b...d88P.888........888........
.."Y31337P"..888....Y888.8888831337.888....888.."Y31337P"..888........8888831337.
.................................................................................
.................................................................................
....................................................| ENGINEERING |..............
`;

const oneLogo = `
..d88888b...888b....888.8888888888.
d88P"."Y88b.8888b...888.888........
888.....888.88888b..888.888........
888.....888.888Y88b.888.8888888....
888.....888.888.Y88b888.888........
888.....888.888..Y88888.888........
Y88b...d88P.888...Y8888.888........
."Y88888P"..888....Y888.8888888888.
...................................
...................................
...................................
`;

const hopeLogo = `
888....888...d88888b...8888888b...8888888888.
888....888.d88P"."Y88b.888...Y88b.888........
888....888.888.....888.888....888.888........
8888888888.888.....888.888...d88P.8888888....
888....888.888.....888.8888888P"..888........
888....888.888.....888.888........888........
888....888.Y88b...d88P.888........888........
888....888.."Y88888P"..888........8888888888.
.............................................
.............................................
................| ENGINEERING |..............
`;

const oneHopeLowerCaseLogo = `
  /***
   *    ...........................888.................................
   *    ...........................888.................................
   *    ...........................888.................................
   *    ..d88b...88888b.....d88b...88888b.....d88b...88888b.....d88b...
   *    d88""88b.888."88b.d8P..Y8b.888."88b.d88""88b.888."88b.d8P..Y8b.
   *    888..888.888..888.88888888.888..888.888..888.888..888.88888888.
   *    Y88..88P.888..888.Y8b......888..888.Y88..88P.888.d88P.Y8b......
   *    ."Y88P"..888..888.."Y8888..888..888.."Y88P"..88888P"..."Y8888..
   *    .............................................888...............
   *    .............................................888...............
   *    ......| ENGINEERING |........................888...............
   */
`;

const techLogo = `
/***
 *    .________.________..______..__....__.
 *    /......../........|/......\/..|../..|
 *    $$$$$$$$/$$$$$$$$//$$$$$$..$$.|..$$.|
 *    ...$$.|..$$.|__...$$.|..$$/$$.|__$$.|
 *    ...$$.|..$$....|..$$.|.....$$....$$.|
 *    ...$$.|..$$$$$/...$$.|...__$$$$$$$$.|
 *    ...$$.|..$$.|_____$$.\__/..$$.|..$$.|
 *    ...$$.|..$$.......$$....$$/$$.|..$$.|
 *    ...$$/...$$$$$$$$/.$$$$$$/.$$/...$$/.
 *    .....................................
 *    .....................................
 *    .....................................
 */
`;

module.exports = { oneHopeLogo };
